import { EventEmitter, Injectable } from '@angular/core';
import { ZapResponse } from '../models/responses/zap-response';
import { CalComIntegrationResponse } from '../models/responses/calcom-integration-response';
import { CallLogResponse } from '../models/responses/call-log-response';
import { TelegramIntegrationResponse } from '../models/responses/telegram-integration-response';
import { PhoneSettingsResponse } from '../models/responses/phone-settings-response';
import { NotificationResponse } from '../models/responses/notification-response';
import { SmsSettingsResponse } from '../models/responses/sms-settings-response';
import { CallBackSettingsResponse } from '../models/responses/call-back-settings-response';
import { AutoCallBackSettingsResponse } from '../models/responses/auto-call-back-settings-response';
import { GoogleSheetsIntegrationResponse } from '../models/responses/google-sheets-integration-response';
import { MakeResponse } from '../models/responses/make-response';
import { CallLogViewPayload } from '../models/views/call-log-view-payload';
import { CustomApiCallResponse } from '../models/responses/custom-api-call-response';
import { WebhookResponse } from '../models/responses/webhook-response';
import { KeypadInputToolResponse } from '../models/responses/keypad-input-tool-response';
import { DtmfToolResponse } from '../models/responses/dtmf-tool-response';
import { HangUpToolResponse } from '../models/responses/hang-up-tool-response';


@Injectable({
  providedIn: 'root'
})
export class AiConfigurationPageEventsService {
  onCreateNewAssistantEvent: EventEmitter<any> = new EventEmitter<any>();
  onEditAssistantEvent: EventEmitter<any> = new EventEmitter<any>();
  onZappierIntegrationAddedEvent: EventEmitter<ZapResponse> = new EventEmitter<ZapResponse>();
  onGoogleSheetAddedEvent: EventEmitter<GoogleSheetsIntegrationResponse> = new EventEmitter<GoogleSheetsIntegrationResponse>();
  onMakeIntegrationAddedEvent: EventEmitter<MakeResponse> = new EventEmitter<MakeResponse>();
  onCustomApiCallAddedEvent: EventEmitter<CustomApiCallResponse> = new EventEmitter<CustomApiCallResponse>();
  onKeypadInputToolAddedEvent: EventEmitter<KeypadInputToolResponse> = new EventEmitter<KeypadInputToolResponse>();
  onDtmfToolAddedEvent: EventEmitter<DtmfToolResponse> = new EventEmitter<DtmfToolResponse>();
  onHangUpToolAddedEvent: EventEmitter<HangUpToolResponse> = new EventEmitter<HangUpToolResponse>();
  onWebhookAddedEvent: EventEmitter<WebhookResponse> = new EventEmitter<WebhookResponse>();
  onSmsSettingsAddedEvent: EventEmitter<SmsSettingsResponse> = new EventEmitter<SmsSettingsResponse>();
  onMissedCallBackActionsSettingsAddedEvent: EventEmitter<AutoCallBackSettingsResponse> = new EventEmitter<AutoCallBackSettingsResponse>();
  onCallBackSettingsAddedEvent: EventEmitter<CallBackSettingsResponse> = new EventEmitter<CallBackSettingsResponse>();
  onNotificationIntegrationAddedEvent: EventEmitter<NotificationResponse> = new EventEmitter<NotificationResponse>();
  onCalIntegrationAddedEvent: EventEmitter<CalComIntegrationResponse> = new EventEmitter<CalComIntegrationResponse>();
  onTelegramIntegrationAddedEvent:EventEmitter<TelegramIntegrationResponse> = new EventEmitter<TelegramIntegrationResponse>();
  onRefreshAiAgentEvent: EventEmitter<any> = new EventEmitter<any>();
  onCallLogViewClickedEvent = new EventEmitter<CallLogResponse>();
  onCallLogBackClickedEvent: EventEmitter<any> = new EventEmitter<any>();
  onCampaignCallLogViewClickedEvent: EventEmitter<CallLogResponse> = new EventEmitter<CallLogResponse>();
  onCallLogViewBackedClickedEvent: EventEmitter<any> = new EventEmitter<any>();
  onCallLogViewDeletedEvent: EventEmitter<CallLogResponse> = new EventEmitter<CallLogResponse>();
  onTabToRenderEvent: EventEmitter<number> = new EventEmitter<number>();
  onSelectPhoneNumberEvent: EventEmitter<PhoneSettingsResponse> = new EventEmitter<PhoneSettingsResponse>();
  updateCurrentCallLogInList?: (callLog: CallLogResponse, absoluteIndex: number) => void;

}
